var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCsvIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_580_24279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7498 2.91669H20.0832V17.0834H11.7498M11.7498 0.416687L0.916504 2.50002V17.5L11.7498 19.5834V0.416687Z",
    stroke: "#344054",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.08331L7.58333 13.75M4.25 13.75L7.58333 7.08331M11.75 4.58331H14.25V5.41665H11.75V4.58331ZM15.9167 4.58331H18.4167V5.41665H15.9167V4.58331ZM11.75 7.08331H14.25V7.91665H11.75V7.08331ZM15.9167 7.08331H18.4167V7.91665H15.9167V7.08331ZM11.75 9.58331H14.25V10.4166H11.75V9.58331ZM15.9167 9.58331H18.4167V10.4166H15.9167V9.58331ZM11.75 12.0833H14.25V12.9166H11.75V12.0833ZM15.9167 12.0833H18.4167V12.9166H15.9167V12.0833ZM11.75 14.5833H14.25V15.4166H11.75V14.5833ZM15.9167 14.5833H18.4167V15.4166H15.9167V14.5833Z",
    stroke: "#344054",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_580_24279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCsvIcon);
export default __webpack_public_path__ + "static/media/download-csv-icon.d2cd47151e5b43c8a4c95b9d6e47fda6.svg";
export { ForwardRef as ReactComponent };